import { parse } from 'query-string';

const isPreviewMode = () => {
  const url = parse(window.location.search);
  return !!(url.preview && url.preview === 'true');
};

export default isPreviewMode;
